module.exports = __webpack_public_path__ + "static/media/pdf.a4c2aa38.svg";